
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 378 378"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_3801_9189)"}},[_c('path',{attrs:{"fill":"#D0EFEC","d":"M179.063 20.56a170.14 170.14 0 0 1 172.08 121.083 170.1 170.1 0 0 1 5.155 74.816l-44.527-6.885a125.08 125.08 0 0 0-30.859-103.034 125.08 125.08 0 0 0-99.44-40.987l-2.409-44.992Z"}}),_c('path',{attrs:{"stroke":"#F9A241","stroke-dasharray":"21.6 32.4","stroke-miterlimit":"10","stroke-width":"3.24","d":"M116.112 314.614c68.444 39.516 155.963 16.066 195.479-52.378s16.065-155.962-52.379-195.478C190.768 27.24 103.25 50.691 63.734 119.135s-16.066 155.962 52.378 195.478Z"}}),_c('path',{attrs:{"fill":"#F9CE62","d":"M295.904 298.415a152.52 152.52 0 0 1-198.625 14.54 152.526 152.526 0 0 1-43.686-194.306l23.773 12.685a125.58 125.58 0 0 0 54.99 171.625 125.58 125.58 0 0 0 144.513-23.616z"}}),_c('path',{attrs:{"fill":"#73D6D3","d":"M136.782 279.892c49.59 28.631 113 11.64 141.63-37.949s11.64-112.999-37.95-141.63c-49.589-28.63-112.999-11.64-141.63 37.95-28.63 49.589-11.639 112.999 37.95 141.629"}})]),_c('defs',[_c('clipPath',{staticClass:"i-clip0_3801_9189"},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h378v378H0z"}})])])])
          )
        }
      }
    